module.exports = __webpack_public_path__ + "img/right-jiantou.5084851f.png";